import React from 'react';
import {useUnifyAdminStore} from '../AdminStore';
import * as StyledComponents from '../StyledComponents';
import get from 'lodash/get';
import { t } from 'i18next';

export const AppIdField = (): JSX.Element => {
    /**
     * Hooks
     */

    const permissions = useUnifyAdminStore(state => state.permissions);

    /**
     * Data Store
     */
    const sideSheetData = useUnifyAdminStore((state) => state.sideSheetData);
    const updateSideSheetData = useUnifyAdminStore(
        (state) => state.updateSideSheetData
    );
    const sideSheetSubWorkflowData = useUnifyAdminStore(
        (state) => state.sideSheetDataSubWorkflow
    );
    const isWorkflowSideSheetCollapse = useUnifyAdminStore(
        (state) => state.isWorkflowSideSheetCollapse
    );

    /**
     * Local Component derived states
     */
    const appIdFieldValue = get(
        !isWorkflowSideSheetCollapse ? sideSheetSubWorkflowData : sideSheetData,
        'appId',
        ''
    );

    const handleUpdateNameField = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        return updateSideSheetData({
            fieldName: event.target.name,
            value: event.target.value,
        });
    };

    return (
        <>
            <StyledComponents.StyledInput
                dataTestId={`appId-input`}
                helperText={t('appsAndWorkflows.appIdHelper')}
                errorMessage={t('appsAndWorkflows.appIdError')}
                id={`appId-name-input`}
                inputDivider="left"
                label={t('appsAndWorkflows.appId')}
                name="appId"
                isRequired
                onChange={handleUpdateNameField}
                onInputClear={function noRefCheck() {
                }}
                placeholder={`${appIdFieldValue} ${t('appsAndWorkflows.appId')}`}
                value={appIdFieldValue}
                isDisabled={permissions?.hasAppReadOnlyPermissions && !permissions?.hasAppSuperAdminPermissions && !permissions.hasAppUpdatePermissions}
            />
        </>
    );
};
